export enum Tabs {
    whitelist = 'whitelist',
    myDelegations = 'myDelegations',
    myDelegators = 'myDelegators',
}

export const DEFAULT_OPTIONS = [
    { value: Tabs.whitelist, label: 'All Delegates' },
    { value: Tabs.myDelegations, label: 'My Delegates' },
];

export const EXTENDED_OPTIONS = [
    ...DEFAULT_OPTIONS,
    { value: Tabs.myDelegators, label: 'ICE Delegated To Me' },
];
